import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { continuitySchema } from "./continuity.js";
import { z } from "zod/v4";
//#region src/schemas/space-mesh/dispatch-brief.ts
const briefLineSchema = z.preprocess(trimmedStringFromUnknown, z.string().min(1));
const dispatchBriefSchema = z.strictObject({
	activatedBy: briefLineSchema,
	sourceMessage: briefLineSchema,
	replyTarget: briefLineSchema,
	continuity: continuitySchema,
	whatYouCanDoNow: briefLineSchema
});
//#endregion
export { dispatchBriefSchema };

//# sourceMappingURL=dispatch-brief.js.map